import { useEffect, useState } from "react";
import { apiFetch } from "../lib/auth";
import { SourceDiagnosticsPanel } from "../cma/CascadePanels";
import type { ProviderDiagnostic } from "../cma/cascade";

/**
 * THE OPERATOR'S "SOURCE DIAGNOSTICS" (owner decision 3, 2026-10-20). One row per outside provider:
 * rung, status, reason code, last answer time.
 *
 * WHO SEES IT IS DECIDED ON THE SERVER. `GET /api/admin/source-diagnostics` sits behind the admin
 * gate (`authz.require_admin`) and then `VALUBRIEF_PROVIDER_DIAG_EMAILS` (default
 * admin@valubrief.ai). Anyone else gets a 403, and on any failure this renders nothing at all: no
 * empty box, no error, nothing that says a list exists.
 */
export interface SourceDiagnosticsBody {
  providers: ProviderDiagnostic[];
}

export const getSourceDiagnostics = () =>
  apiFetch<SourceDiagnosticsBody>("/api/admin/source-diagnostics");

export function AdminSourceDiagnostics() {
  const [rows, setRows] = useState<ProviderDiagnostic[] | null>(null);
  useEffect(() => {
    let live = true;
    // Through a resolved promise so a fetch stub that throws synchronously cannot escape the effect.
    Promise.resolve()
      .then(() => getSourceDiagnostics())
      .then((b) => { if (live) setRows(Array.isArray(b?.providers) ? b.providers : null); })
      .catch(() => { if (live) setRows(null); });
    return () => { live = false; };
  }, []);
  return <SourceDiagnosticsPanel rows={rows} />;
}
